import { useNavigationActivityTypes } from '../navigation-constants';
import { ActivityItem } from '../navigation-types';

export const useNavigationConfiguration = (): Array<ActivityItem> => {
    const {
        NEW_COURSES,
        LEGACY_ACTIVITIES,
        PSR,
        SKILL_QUESTS,
        REVISE_FIVE,
        ASSESSMENTS,
        TESTS
    } = useNavigationActivityTypes();

    return [
        LEGACY_ACTIVITIES,
        NEW_COURSES,
        PSR,
        SKILL_QUESTS,
        REVISE_FIVE,
        ASSESSMENTS,
        TESTS
    ];
};
